import React, { useEffect, useState } from 'react'
import CreditCardDetail from './CreditCardDetail'
import { InputError, Select } from '@foodsby/nutrient'

// const [{ subscription }] = useStateValue()

const BillingInfo = ({
  creditCards,
  creditCardsError,
  errors,
  handleBlur,
  handleChange,
  setFieldTouched,
  setFieldValue,
  touched,
  values,
}) => {
  const options = [
    ...creditCards.map(card => ({
      value: card.ccProfileId,
      label: `XXXX-XXXX-XXXX-${card.lastFour}`,
    })),
    { value: -1, label: 'Add New Card' },
  ]
  const [didSetDefaultCard, setDidSetDefaultCard] = useState(false)

  useEffect(() => {
    if (!didSetDefaultCard && creditCards && creditCards.length === 1) {
      setFieldValue('SelectedCard', creditCards[0].ccProfileId)
      setDidSetDefaultCard(true)
    }
  }, [
    creditCards,
    didSetDefaultCard,
    handleBlur,
    setFieldTouched,
    setFieldValue,
    values,
  ])

  return (
    <div>
      {creditCards && creditCards.length > 0 ? (
        <div className="Select">
          <label htmlFor="creditCard">Choose Card</label>
          <Select
            id="SelectedCard"
            name="SelectedCard"
            onBlur={handleBlur}
            onChange={option => {
              setFieldValue('SelectedCard', option.value)
            }}
            options={options}
            placeholder="Select Credit Card"
            value={
              options.filter(card => card.value === values.SelectedCard) || -1
            }
          />
          <InputError>{touched.SelectedCard && errors.SelectedCard}</InputError>
          {values.SelectedCard === -1 && (
            <CreditCardDetail
              creditCards={creditCards}
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              touched={touched}
              values={values}
            />
          )}
        </div>
      ) : (
        <CreditCardDetail
          creditCards={creditCards}
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          touched={touched}
          values={values}
        />
      )}
      <InputError>{creditCardsError}</InputError>
    </div>
  )
}

export default BillingInfo
